import React, { useEffect, useState } from 'react'
import Table from '../Table/Table'
import Table_Buttons from '../Table_Button/Table_button'
import { API } from '../../Redux/actions/API'
import Navbar from '../Navbar/Navbar'

function Staking_Claim_History() {
  let user = 224466
  const [referralApi, setreferralApi] = useState([])
  const [leftreferralApi, setleftreferralApi] = useState([])
  const [search, steSearch] = useState(user)
  const [radiobox, setRadiobox] = useState('')
  const [currentPage, setcurrentPage] = useState(1)
  const [select, setSelect] = useState('2')
  const [listPerpage, setlistPerpage] = useState(10)
  const [currentPage2, setcurrentPage2] = useState(1)
  const [listPerpage2, setlistPerpage2] = useState(10)
  const [fromdate, setFromdate] = useState('')
  const [todate, setTodate] = useState('')
  const [positionfilter, setpositionfilter] = useState('0')
  const [StatusFilter, setStatusFilter] = useState('2')

  let arrayLeft = []
  //   let value = 2
  const referral_API = async () => {
    try {
      // console.log("user=>",search);
      let responceRight = await API?.post('/getTotalDeposite', {
        
      })
      console.log('My_Team', responceRight?.data?.data[0])
      responceRight = responceRight?.data?.data[0]
      setleftreferralApi([])

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: `${item?.uid} `,
          radio: `${item?.wallet}`,
          unstake_date: `${item?.dd}`,
          currentStatus: `${item?.days} `,
          totalwith: `${item?.txn} `,
          unstake_date_end: `${item?.over_date} `,
            TotalIncome: `${item?.totalpaycoin} `,
          coin: `${item?.coin} `,
          action:(
            <input type="button"  value="Claim"/>
          )
        })

        setleftreferralApi(arrayLeft)
      })
    } catch (e) {
      console.log('Error While calling Myteam API', e)
    }
  }

  useEffect(() => {
    referral_API()
  }, [positionfilter, StatusFilter])

  const indexOfLastPost = currentPage * listPerpage
  const indexOfFirstPage = indexOfLastPost - listPerpage
  const indexOfLastPost2 = currentPage2 * listPerpage2
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost)
  const currentPostleft = leftreferralApi.slice(indexOfFirstPage2, indexOfLastPost2)

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: 'S.No.', accessor: 'sr' },
      { Header: 'User ID', accessor: 'id' },
      { Header: 'Wallet', accessor: 'radio' },
      { Header: 'Staking Dorado Amount', accessor: 'coin' },
      { Header: 'Staking Days', accessor: 'currentStatus' },
      { Header: 'Start Date & Time', accessor: 'unstake_date' },
      { Header: 'End Date & Time', accessor: 'unstake_date_end' },
      { Header: 'Claim Baby Doge Amount', accessor: 'TotalIncome' },
      // {Header:'Action',accessor:'action'}
    ],
  })

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Deposite History</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: 'scroll' }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Staking_Claim_History
